var _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g10, _g11, _g12, _g13, _g14, _g15, _g16;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCalendar6(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 58 58",
    style: {
      enableBackground: "new 0 0 58 58"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M42.899,4.5c-0.465-2.279-2.484-4-4.899-4c-0.553,0-1,0.447-1,1s0.447,1,1,1c1.654,0,3,1.346,3,3s-1.346,3-3,3 c-0.553,0-1,0.447-1,1s0.447,1,1,1c2.414,0,4.434-1.721,4.899-4H56v9H2v-9h14h3c0.553,0,1-0.447,1-1s-0.447-1-1-1h-1.816 c0.414-1.162,1.514-2,2.816-2c1.654,0,3,1.346,3,3s-1.346,3-3,3c-0.553,0-1,0.447-1,1s0.447,1,1,1c2.757,0,5-2.243,5-5 s-2.243-5-5-5c-2.414,0-4.434,1.721-4.899,4H0v13v40h58v-40v-13H42.899z M56,55.5H2v-38h54V55.5z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26,2.5c1.654,0,3,1.346,3,3s-1.346,3-3,3c-0.553,0-1,0.447-1,1s0.447,1,1,1c2.757,0,5-2.243,5-5s-2.243-5-5-5 c-0.553,0-1,0.447-1,1S25.447,2.5,26,2.5z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32,2.5c1.654,0,3,1.346,3,3s-1.346,3-3,3c-0.553,0-1,0.447-1,1s0.447,1,1,1c2.757,0,5-2.243,5-5s-2.243-5-5-5 c-0.553,0-1,0.447-1,1S31.447,2.5,32,2.5z"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 22,
    cy: 24.5,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 29,
    cy: 24.5,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 36,
    cy: 24.5,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 43,
    cy: 24.5,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 50,
    cy: 24.5,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 8,
    cy: 32.5,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 15,
    cy: 32.5,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 22,
    cy: 32.5,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 29,
    cy: 32.5,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 36,
    cy: 32.5,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 43,
    cy: 32.5,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 50,
    cy: 32.5,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 8,
    cy: 39.5,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 15,
    cy: 39.5,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 22,
    cy: 39.5,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 29,
    cy: 39.5,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 36,
    cy: 39.5,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 43,
    cy: 39.5,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 50,
    cy: 39.5,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 8,
    cy: 47.5,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 15,
    cy: 47.5,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 22,
    cy: 47.5,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 29,
    cy: 47.5,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 36,
    cy: 47.5,
    r: 1
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null)), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null)), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", null)), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", null)), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", null)), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", null)), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", null)), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", null)), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", null)), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", null)), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", null)), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", null)), _g14 || (_g14 = /*#__PURE__*/React.createElement("g", null)), _g15 || (_g15 = /*#__PURE__*/React.createElement("g", null)), _g16 || (_g16 = /*#__PURE__*/React.createElement("g", null)));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalendar6);
export default __webpack_public_path__ + "static/media/calendar-6.aee2f496d591d22a5b5096b4f43ee446.svg";
export { ForwardRef as ReactComponent };